import { interactiveResize } from '../../actions/actions';

/**
 * @type {import(@reduxjs/toolkit).CreateSliceOptions}
 */
const zonesSliceOptions = {
  name: 'zones',
  initialState: [
    {
      zone_id: 'default',
      left: 0,
      top: 0,
      bottom: 0,
      right: 0,
    },
  ],
  extraReducers: {
    [interactiveResize](state, action) {
      const { zones } = action.payload;

      return zones.length > 0 ? zones : state;
    },
  },
};

export default zonesSliceOptions;
